module.exports = __webpack_public_path__ + "img/under-construction.cfb47478.gif";